import './clubview.scss'

import { ERROR, LOADING, READY, useVisualState } from '../../../../hooks/useVisualState'
import React, { useEffect } from 'react'

import TeamCard from '../../../../components/Cards/TeamCard/TeamCard'
import { get } from '../../../../helpers/request'
import t from '../../../../helpers/i18n'
import { withRouter } from 'react-router-dom'

const ClubView = ({ history, match }) => {
  const [[clubState, club], setClub] = useVisualState()
  const [[teamsState, teams], setTeams] = useVisualState()
  const clubId = match.params.clubId

  useEffect(() => {
    setClub(LOADING)
    get('/soccer/clubs/' + clubId)
      .then((response) => {
        setClub(READY, response)
      })
      .catch((error) => {
        setClub(ERROR, error)
      })
  }, [clubId, setClub])

  useEffect(() => {
    setTeams(LOADING)
    get('/soccer/clubs/' + clubId + '/teams')
      .then((response) => {
        setTeams(READY, response)
      })
      .catch((error) => {
        setTeams(ERROR, error)
      })
  }, [clubId, setTeams])

  return (
    <div>
      {clubState === READY && (
        <div>
          <h2>{t('titles.Club')} {club.name}</h2>
          <button
            onClick={() =>
              history.push('/soccer/clubs/' + clubId + '/teams/new')
            }
          >
            {t('buttons.Add_team')}
          </button>
        </div>
      )}
      {teamsState === READY && (
        <div className='container-teams'>
          <ul>
            {teams.map((team) => (
              <TeamCard
                key={team.team_id}
                teamName={team.name}
                subtypeSport='U-23 MEN'
                ownedTeam='YERNOS DE PARRA FC'
                divisionTeam='LIGA ZÉNIT'
                onClick={() =>
                  history.push(
                    '/soccer/clubs/' + clubId + '/teams/' + team.team_id
                  )
                }
              />
            ))}
          </ul>
        </div>
      )}

      {teamsState === ERROR && <div>Error: {teams.code}</div>}
    </div>
  )
}

export default withRouter(ClubView)
